import { TRACKING_MSG_TYPE, TRACKING_TYPE, SELECT_ORDER_TEXT } from '@/utils/constants';
import { inject, observer } from 'mobx-react';
import { getTrans, handleClickHistoryButton } from '@/utils/tools';
import Msg from '@/components/Msg';
import React from 'react';
import SingleButton from '@/components/SingleButton';
import { tracker } from '@/utils/tracking';
import { getChildInject } from '@/utils/instantLoaded/tools';
import { updateDialogueInfo } from '@/utils/sessionUtils';

const PREFIX = 'live-container';

@tracker
@inject(getChildInject('initStore', 'agentStore', 'modalStore'))
@observer
export default class SelectorOrder extends React.PureComponent {

  static defaultProps = {
    // props
    msgContent: '',
    btnContent: '',
    dialogueId: '',
    dialogueType: '',
    isDisabled: false,
    // stores
    initStore: {},
    modalStore: {},
    agentStore: {},
  };

  constructor(props) {
    super(props);
    const {
      dialogueId,
      initStore,
      buttonType,
      btnContent,
      nodePointId,
      buttonId,
      hasAnnouncement,
      isHistory,
      historyDialogueId,
      historySessionId,
    } = this.props;
    this.timer = null;
    this.trackingname = TRACKING_TYPE.AGENT;
    this.autoOpenCount = 0;
    this.trackingdata = {
      node_point_id: nodePointId || '',
      chat_session_id: isHistory ? historySessionId : (initStore.sessionId || ''),
      chat_dialogue_id: isHistory ? historyDialogueId : dialogueId,
      button_type: buttonType,
      button_text: btnContent,
      button_id: buttonId || '',
      if_history: isHistory ? TRACKING_MSG_TYPE.HISTORY : TRACKING_MSG_TYPE.REAL_TIME,
    };
  }

  handleJumpClick = () => {
    const {
      dialogueId,
      dialogueType,
      node_id,
      modalStore,
      is_seller,
      show_type,
      isForRR,
      nodePointId,
      disabledBtn,
      taskbotName,
      isHistory,
      historyDialogueId,
      historySessionId,
      customCallback = {},
    } = this.props;

    if (isHistory) {
      handleClickHistoryButton();
      return;
    }
    modalStore.UPDATE_MODAL_ORDER_LIST({
      nodePointId,
      dialogueId,
      dialogueType,
      node_id,
      is_seller,
      isSelectOrder: true,
      show_type,
      isForRR,
      taskbotName,
      isHistory,
      historyDialogueId,
      historySessionId,
      customCallback,
    });
    modalStore.SHOW_ORDERLIST_MODAL();

  };

  render() {
    const {
      msgContent,
      agentStore,
      disabledBtn,
      passedRef,
      shouldDisplayInstantly,
      listPos,
    } = this.props;

    const { loadingInAgent, inAgent } = agentStore;
    const trackingdata = JSON.stringify(this.trackingdata);

    clearTimeout(this.timer);
    const that = this;
    this.timer = setTimeout(() => {
      if (!that.props.isHistory && !inAgent && this.autoOpenCount === 0 && !this.props.hasAnnouncement && shouldDisplayInstantly) {
        that.handleJumpClick();
        this.autoOpenCount += 1;
        listPos
          && updateDialogueInfo(
            { shouldDisplayInstantly: false, },
            listPos,
          );
        clearTimeout(this.timer);
      }
    }, 2000);

    return <div className={PREFIX}>
      <Msg content={msgContent} />
      <SingleButton
        disabled={disabledBtn}
        passedRef={passedRef}
        trackingname={this.trackingname}
        trackingdata={trackingdata}
        text={getTrans(SELECT_ORDER_TEXT)}
        handleClick={this.handleJumpClick}
      />
    </div>;
  }
}
